<template>
  <div>
    <vx-card class="mt-3">
      <vs-table
        :sst="true"
        v-if="dataTableExcisetanker"
        @search="handleSearch"
        @change-page="handleChangePage"
        :data="dataTableExcisetanker"
        @sort="handleSort"
        v-model="selectedVessel"
        :max-items="100"
        pagination
        search
      >
        <template slot="header">
          <vs-button
            style="margin-left:5px;margin-bottom:5px"
            icon-pack="feather"
            icon="icon-plus"
            @click="popupActive2=true"
          >Add Vessel</vs-button>
        </template>
        <template slot="thead">
          <vs-th sort-key="no">No.</vs-th>
          <vs-th sort-key="mmsi">MMSI</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="imo_number">radio channel</vs-th>
          <vs-th sort-key="imo_number">IMO</vs-th>

          <vs-th sort-key="ship_type_name">Ship type</vs-th>
          <vs-th sort-key="ship_class">Ship class</vs-th>
          <vs-th sort-key="call_sign">Call sign</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
            <vs-td :data="data[indextr].id">{{ tr.index+1 }}</vs-td>
            <vs-td :data="data[indextr].mmsi">{{ data[indextr].mmsi }}</vs-td>
            <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
            <vs-td :data="data[indextr].radio_channel">{{ data[indextr].radio_channel }}</vs-td>
            <vs-td :data="data[indextr].imo_number">{{ data[indextr].imo_number }}</vs-td>
            <vs-td :data="data[indextr].ship_type_name">{{ data[indextr].ship_type_name }}</vs-td>
            <vs-td :data="data[indextr].ship_class">{{ data[indextr].ship_class }}</vs-td>
            <vs-td :data="data[indextr].call_sign">{{ data[indextr].call_sign }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- ------------------- -->

    <vs-popup fullscreen title="ค้นหาหมายเลข MMSI" :active.sync="popupActive2">
      <div class="demo-alignment"></div>
      <vs-button class="pb-3 ml-4 mb-3" icon="save" @click="groupmmsi()">Save</vs-button>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="12">
          <h3 class="pt-3 pr-2">ค้นหารายการเรื่อ :</h3>
          <vs-input class="mb-3" placeholder="MMSI,Name" v-model="mmsi" />

          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container mb-3"
            color="warning"
            icon-pack="feather"
            icon="icon-search"
            @click="searchingVessel(),openLoadingContained()"
          >Search</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="12">
          <h3 class="pt-3 pr-2">รายการเรื่อในโครงการ {{selected.name}}</h3>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
          <VuePerfectScrollbar class="scroll-area--customizer-group pt-4 pb-6 pr-2">
            <table style="font-size:12px;">
              <tr v-for="(item , index) in dataSearchVessel " :key="index">
                <vs-divider />
                <td>
                  <b>{{index+1}}.</b>
                </td>
                <td>
                  <feather-icon icon="AnchorIcon" svgClasses="w-5 h-5" class="pr-2"></feather-icon>
                </td>
                <td>
                  <b>{{item.mmsi}}</b>
                  <br />
                  {{item.name}}
                </td>
                <td>
                  <vs-button
                    radius
                    color="success"
                    type="filled"
                    icon="add"
                    @click="selectAddVessel(item)"
                  ></vs-button>
                </td>
              </tr>
            </table>
          </VuePerfectScrollbar>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
          <VuePerfectScrollbar class="scroll-area--customizer-group pt-4 pb-6 pr-2">
            <table style="font-size:12px;">
              <tr v-for="(item , index) in excisemmsiListDetail " :key="index">
                <vs-divider />
                <td>
                  <b>{{index+1}}.</b>
                </td>
                <td>
                  <feather-icon icon="AnchorIcon" svgClasses="w-5 h-5" class="pr-2"></feather-icon>
                </td>

                <td>
                  <b>{{item.mmsi}}</b>
                  <br />
                  {{item.name}}
                </td>
                <td>
                  <p v-if="item.statusnew" style="color:green;font-weight: bold;">New</p>
                </td>
                <td>
                  <vs-button
                    radius
                    color="danger"
                    type="filled"
                    icon="remove"
                    @click="removeVessel(item)"
                  ></vs-button>
                </td>
              </tr>
            </table>
          </VuePerfectScrollbar>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import axios from "axios";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { API_BASE_URL } from '@/constants'

export default {
  data() {
    return {
      popupActive2: false,
      accessEmail: "",
      accessToken: "",
      excisemmsiList: "",
      countdataExcise: 0,
      excisemmsiListDetail: [],
      statusSearch: true,
      idVesselGroup: "",
      selected: [],
      selectedVessel: [],
      mmsi: "",
      dataSearchVessel: [],
      selectAdd: [],
      dataTableExcisetanker: [],
      statusVesselVallback: false,
    };
  },
  watch: {
    statusVesselVallback() {
      if (this.statusVesselVallback == true) {
        this.dataTableExcisetanker = this.excisemmsiListDetail;
      }
    },
    excisemmsiListDetail() {
      for (let i = 0; i < this.excisemmsiListDetail.length; i++) {
        this.excisemmsiListDetail[i].index = i;
      }
    }
  },
  created() {
    this.$vs.loading();
  },
  mounted() {
    this.$vs.loading();
    this.$store.dispatch("updateTitlePage", "Vessel group");
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    // this.idVesselGroup = localStorage.getItem("idVesselGroup");
    this.getdataExciseTanker(localStorage.getItem("idVesselGroup"));
    axios
      .get(`${API_BASE_URL}/admin/vessels.json`, {
        params: {
          limit: 100
          //   "q[is_visible_true]": 1
        },
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.dataSearchVessel = response.data;
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
      })
      .catch(error => {
        console.log("API vessels  error:", error);
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
      });
  },
  methods: {
    groupmmsi() {
      let stringmmsi = "";
      for (let i = 0; i < this.excisemmsiListDetail.length; i++) {
        if (i == this.excisemmsiListDetail.length - 1) {
          stringmmsi = stringmmsi + this.excisemmsiListDetail[i].mmsi;
        } else {
          stringmmsi = stringmmsi + this.excisemmsiListDetail[i].mmsi + ",";
        }
      }
      console.log("string mmsi", stringmmsi);
      this.saveGroup(stringmmsi);
    },
    saveGroup(stringmmsi) {
      this.$vs.loading();
      let editVesselGroup = {
        name: this.selected.name,
        mmsi_list: stringmmsi,
        icon_type: this.selected.icon_type
      };
      axios
        .put(
          `${API_BASE_URL}/admin/vessel_groups/${this.selected.id}.json`,
          editVesselGroup,
          {
            headers: {
              "X-User-Email": "api@excise-online.com",
              "X-User-Token": "m2Nc1hmx7s97eCA1FMYA"
            }
          }
        )
        .then(response => {
          console.log("update ok", response.data);
          let routeData = this.$router.resolve({ name: "editVesselGroup" });
          window.open(routeData.href, "_parent");
          this.$vs.loading.close();
        })

        .catch(error => {
          this.$vs.loading.close();
        });
    },
    removeVessel(vessel) {
      let numLength = this.excisemmsiListDetail.length;
      for (let i = 0; i < numLength; i++) {
        if (vessel.mmsi == this.excisemmsiListDetail[i].mmsi) {
          this.excisemmsiListDetail.splice(i, 1);
          break;
        }
      }
    },
    selectAddVessel(vessel) {
      let status = false;
      let numLength = this.excisemmsiListDetail.length;
      console.log("nummm", numLength);

      for (let i = 0; i < numLength; i++) {
        if (vessel.mmsi == this.excisemmsiListDetail[i].mmsi) {
          status = true;
          this.$vs.notify({
            title: "ผิดพลาด",
            text: "ไม่สามารถทำรายการได้ เนื่องเรือซ้ำ",
            color: "danger",
            position: "top-center",
            icon: "query_builder"
          });
          break;
        }
      }
      if (status == false) {
        vessel.statusnew = true;
        this.selectAdd.unshift(vessel);
        this.excisemmsiListDetail.unshift(vessel);
        console.log("vessel", vessel);
      }
    },
    openLoadingContained() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      });
    },
    async getdataExciseTanker(id) {
      await axios
        .get(`${API_BASE_URL}/admin/vessel_groups/${id}.json`, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          console.log("respose data", response.data);
          this.selected = response.data;
          this.excisemmsiListDetail = response.data.vessels
          this.excisemmsiList = response.data.mmsi_list;
          this.$vs.loading.close();
          this.statusVesselVallback = true;
        })
        .catch(error => {
          console.log("Error call apis :", error);
        })
        .finally(()=>{
          // this.statusVesselVallback = false;
        });

      // this.convertmmsiList();
    },
    async convertmmsiList() {
      var ar = this.excisemmsiList.split(",");
      let x = 0;
      for (let i = 0; i < ar.length; i++) {
        await this.fineExciseTankerList(ar[i]);
        console.log("iii", x);
        if (x == ar.length - 1) {
          this.$vs.loading.close();
          this.statusVesselVallback = true;
        }
        x++;
        console.log("status call back :", this.excisemmsiListDetail);
      }
    },
    fineExciseTankerList(mmsi) {
      axios
        .get(`${API_BASE_URL}/admin/vessels.json`, {
          params: {
            "q[mmsi_or_imei_or_imo_number_or_imn_number_or_radio_channel_or_name_or_ship_class_or_vendor_id_or_call_sign_or_reg_number_or_color_or_description_or_other_com_ch_or_owner_name_or_owner_address_or_owner_phone_or_master_name_or_master_address_or_master_phone_cont]": mmsi,
            "q[is_visible_true]": 1
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          if (response.data[0] != undefined) {
            this.excisemmsiListDetail.push(response.data[0]);
          }
        })
        .catch(error => {
          console.log("vessel list API error:", error);
        });
    },
    searchingVessel() {
      console.log("search");
      axios
        .get(`${API_BASE_URL}/admin/vessels.json`, {
          params: {
            utf8: "✓",
            "q[mmsi_or_imei_or_imo_number_or_imn_number_or_radio_channel_or_name_or_ship_class_or_vendor_id_or_call_sign_or_reg_number_or_color_or_description_or_other_com_ch_or_owner_name_or_owner_address_or_owner_phone_or_master_name_or_master_address_or_master_phone_cont]": this
              .mmsi,
            "q[is_visible_true]": 1
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })

        .then(response => {
          this.dataSearchVessel = response.data;
          console.log("data search vessel", response.data);
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        })
        .catch(error => {
          console.log("API vessels  error:", error);
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        });
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleChangePage(page) {
      console.log(`The user changed the page to: ${page}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    }
  }
};
</script>
<style>
.scroll-area--customizer-group {
  width: 100%;
  height: 100%;
  border-style: inset;
}
</style>
